// extracted by mini-css-extract-plugin
export default {"input_wrapper":"CategorySelect_input_wrapper__j+oV4","select":"CategorySelect_select__GlNmk","search_icon":"CategorySelect_search_icon__LIvuj"};